import script from "./TressAccountResetPasswordForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressAccountResetPasswordForm.vue?vue&type=script&setup=true&lang=ts"

import "./TressAccountResetPasswordForm.vue?vue&type=style&index=0&id=791059d2&lang=scss"

const __exports__ = script;

export default __exports__